import { Component } from '@angular/core';
import { RidContentCard } from '../../../components/rid-content-card/rid-content-card';
import { RidDemoPage } from '../../../components/rid-demo-page/rid-demo-page';

@Component({
  selector: 'app-content-card-page',
  imports: [RidDemoPage, RidContentCard],
  templateUrl: './content-card-page.html',
})
export class ContentCardPage {}
